import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { GetOfferPage } from './pages/GetOfferPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/contact" element={<ContactPage data-id="element-7" />} data-id="element-6" />
        <Route path="/get-offer" element={<GetOfferPage data-id="element-9" />} data-id="element-8" />
        <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-11" />} data-id="element-10" />
        <Route path="/terms" element={<TermsOfServicePage data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}